import React from 'react'
import styles from './index.module.scss'

import Form from '../../Integrations/FormBlock/index'

import icon from '../../img/icons/Icon_team.svg'
import icon2 from '../../img/icons/icon_planing.svg'
import icon3 from '../../img/icons/icon_invoice.svg'
const mainTitle = 'Ask a Question'

export default class SixthBlock extends React.Component {
  render() {
    return (
      <>
        <div className={styles.main}>
          <div>
            <span className={styles.mainTitle}>New Cool Features Coming Soon</span>
            <div className={styles.content}>
              <div>
                <img src={icon2} width="auto" height="auto" alt='icon' />
                <span className={styles.contentTitle}>Invoice Payment</span>
                <p>Create invoices and send them to clients directly from the app</p>
              </div>
              <div>
                <img src={icon} width="auto" height="auto" alt='icon' />
                <span className={styles.contentTitle}>Biotime</span>
                <p>Interact efficiently at the most relevant time</p>
              </div>
              <div>
                <img src={icon3} width="auto" height="auto" alt='icon' />
                <span className={styles.contentTitle}>Budget Planning</span>
                <p>Plan projects budget right in the time tracker</p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.blockForm}>
          <Form mainTitle={mainTitle} />
        </div>
      </>
    )
  }
}